export const changeTableItemsLengthFunc = (data, dataSender, setProductData, setAlertData, userToken, lang, currency, url) => {
    url.searchParams.set('page[size]', data);
    dataSender(
        url?.href,
        'GET',
        false,
        (response) => {
            setProductData(response.data);
            // setGridData((pre) => ({
            //     ...pre,
            //     tbody: convertData(response.data),
            // }));
        },
        (data) => {
            if (data.message) {
                setAlertData({ type: 'error', cont: data.message });
            } else {
                setAlertData(false);
            }
        },
        userToken,
        lang,
        currency
    );
};

export const changeTableItemsLengthFuncSort = (
    dataSort,
    dataSender,
    setProductData,
    setAlertData,
    userToken,
    lang,
    currency,
    url,
    profileData
) => {
    url.searchParams.set('sort', dataSort);
    dataSender(
        url?.href,
        'GET',
        false,
        (response) => {
            setProductData(response.data);
        },
        (data) => {
            if (data.message) {
                setAlertData({ type: 'error', cont: data.message });
            } else {
                setAlertData(false);
            }
        },
        userToken,
        lang,
        profileData?.currency?.code || currency
    );
};
